import React, { useContext } from "react";
import { Button, Heading, Modal, Text } from "@foris/avocado-suite";
import { IGroup } from "@modules/vacancies/contextVacancies/ContextVacancies";
import { useTranslation } from "react-i18next";
import { ContextEDH } from "@context/ContextEDH";

interface GroupActiveModalProps {
  isOpen?: boolean;
  groups?: IGroup[];
  selectedGroup?: IGroup;
  onConfirm?: () => void;
  onCancel?: () => void;
}

const GroupActiveModal = ({
  isOpen,
  selectedGroup,
  groups,
  onCancel,
  onConfirm,
}: GroupActiveModalProps) => {
  const { state } = useContext(ContextEDH);
  const { t } = useTranslation();
  const groupsActiveCount = groups?.filter(group => group.isActive === true)?.length || 0;
  const isModalValidation =
    state?.base?.schedulerEditorClearLinkResources && groupsActiveCount === 1;

  let modalContent = t("bundle.modals.group-active-modal.description-two", {
    action: selectedGroup?.isActive
      ? t("bundle.modals.group-active-modal.state-inactive")
      : t("bundle.modals.group-active-modal.state-active"),
  });
  if (isModalValidation && selectedGroup?.isActive)
    modalContent = `${t("bundle.modals.group-active-modal.description-two", {
      action: t("bundle.modals.group-active-modal.state-inactive"),
    })} ${t("bundle.modals.group-active-modal.description-three")}`;

  return (
    <Modal
      header={
        <Heading type="h2">
          {t("bundle.modals.group-active-modal.title", {
            action: selectedGroup?.isActive
              ? t("bundle.modals.group-active-modal.inactive")
              : t("bundle.modals.group-active-modal.active"),
          })}
        </Heading>
      }
      open={isOpen}
      onClose={onCancel}
      actions={
        <>
          <Button variant="secondary" onClick={onCancel}>
            {t("bundle.actions.cancel")}
          </Button>
          <Button onClick={onConfirm}>{t("bundle.actions.confirm")}</Button>
        </>
      }
    >
      <Text>
        {t("bundle.modals.group-active-modal.description-one")}{" "}
        <span className="isTextMedium">{selectedGroup?.label}</span> {modalContent}
      </Text>
    </Modal>
  );
};

export default GroupActiveModal;
